import HomePage from '@shared/pages/HomePage'
import LoanFormPage from '@shared/pages/loan/new-customer/LoanFormPage'
import WithOfferLoanFormPage from '@shared/pages/loan/returning-customer/LoanFormPage'
import LoginPage from '@/pages/LoginPage'
import LoanApplicationThankYouPage from '@shared/pages/LoanApplicationThankYouPage'
import CustomerOverviewPage from '@shared/pages/CustomerOverviewPage'
import AccountPage from '@shared/pages/AccountPage'
import UpdateAccountPage from '@shared/pages/UpdateAccountPage'
import LoanDetailsPage from '@shared/pages/loan/LoanDetailsPage'
import LoanApplicationDetailsPage from '@shared/pages/loan/LoanApplicationDetailsPage'
import ContactsPage from '@shared/pages/ContactsPage'
import LocationsPage from '@shared/pages/LocationsPage'
import BranchesPage from '@shared/pages/BranchesPage'
import PartnersPage from '@shared/pages/PartnersPage'
import LoanRequestSuspensionPage from '@shared/pages/loan/LoanRequestSuspensionPage'
import LoanFullRepaymentPage from '@shared/pages/loan/LoanFullRepaymentPage'
import LoanStepContactsPage from '@/pages/loan/LoanStepContactsPage'
import ReturningCustomerLoginOtpPage from '@shared/pages/loan/returning-customer/LoginOtpPage'
import SignLoanApplicationOtpPage from '@shared/pages/loan/returning-customer/SignLoanApplicationOtpPage'
import NewCustomerLoginOtpPage from '@shared/pages/loan/new-customer/LoginOtpPage'
import NewCustomerAgreementPage from '@shared/pages/loan/new-customer/AgreementPage'
import LoginOtpPage from '@shared/pages/LoginOtpPage'
import LoansPage from '@shared/pages/LoansPage'
import LoanClosureConfirmationPage from '@shared/pages/loan/LoanClosureConfirmationPage'
import LoanPaymentSchedulePage from '@shared/pages/loan/LoanPaymentSchedulePage'
import BranchDetailsPage from '@shared/pages/BranchDetailsPage'
import UploadPage from '@shared/pages/UploadPage'
import WithoutOfferAgreementPage from '@shared/pages/loan/returning-customer/WithoutOfferAgreementPage'
import WithoutOfferLoginOtpPage from '@shared/pages/loan/returning-customer/WithoutOfferLoginOtpPage'
import WithOfferAgreementPage from '@shared/pages/loan/returning-customer/WithOfferAgreementPage'
import ExternalPaymentsPage from '@shared/pages/ExternalPaymentsPage'
import PaymentRedirectPage from '@shared/pages/PaymentRedirectPage'
import NoBackPage from '@shared/pages/NoBackPage'
import PromotionRedirectPage from '@shared/pages/PromotionRedirectPage'
import ContractSendPage from '@shared/pages/ContractSendPage'
import PreContractSendPage from '@shared/pages/PreContractSendPage'
import LoanPaymentCalculatorPage from '@shared/pages/loan/LoanPaymentCalculatorPage'
import StaticDocumentPage from '@shared/pages/legal/StaticDocumentPage'
import SignContractPage from '@shared/pages/SignContractPage'
import OtpSignContractPage from '@shared/pages/OtpSignContractPage'
import { authenticatedGuard, isFastCheckoutEnabledGuard } from '@shared/utils/routerHelpers'
import PalPartnersPage from '@shared/pages/PalPartnersPage'
import QrScanPage from '@shared/pages/QrScanPage'
import DealerApplicationPage from '@shared/pages/DealerApplicationPage'
import LoanPaymentScheduleSurveyPage from '@shared/pages/LoanPaymentScheduleSurveyPage'
import SigningSurveyPage from '@shared/pages/SigningSurveyPage'

export const routes = [
  {
    path: '/',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: HomePage
  },
  {
    path: '/locations',
    name: 'locations',
    component: LocationsPage
  },
  {
    path: '/branches',
    name: 'branches',
    component: BranchesPage
  },
  {
    path: '/branch/:id',
    name: 'branch',
    component: BranchDetailsPage,
    props: true
  },
  {
    path: '/partners',
    name: 'partners',
    component: PartnersPage
  },
  {
    path: '/scan',
    name: 'scan',
    component: QrScanPage,
    beforeEnter: isFastCheckoutEnabledGuard
  },
  {
    path: '/pal-partners',
    name: 'pal-partners',
    component: PalPartnersPage,
    beforeEnter: isFastCheckoutEnabledGuard
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: ContactsPage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: (route) => { return { pin: route.query.pin } }
  },
  {
    path: '/returning/login-otp',
    name: 'returning-customer-otp',
    component: ReturningCustomerLoginOtpPage
  },
  {
    path: '/returning/without-offer-login-otp',
    name: 'without-offer-login-otp',
    component: WithoutOfferLoginOtpPage
  },
  {
    path: '/returning/sign-otp',
    name: 'returning-customer-sign-otp',
    component: SignLoanApplicationOtpPage
  },
  {
    path: '/new/login-otp',
    name: 'new-customer-otp',
    component: NewCustomerLoginOtpPage
  },
  {
    path: '/login-otp',
    name: 'otp',
    component: LoginOtpPage
  },
  {
    path: '/loans',
    name: 'loans',
    component: LoansPage,
    beforeEnter: authenticatedGuard,
    props: {
      showFullDetailsForWrittenOff: true
    }
  },
  {
    path: '/loan-form',
    name: 'loan-form',
    component: LoanFormPage,
    props: {
      showApr: false,
      showEir: true
    }
  },
  {
    path: '/loan-form/:offerId',
    name: 'loan-form-with-offer-id',
    component: WithOfferLoanFormPage,
    props: {
      showApr: false,
      showEir: true
    }
  },
  {
    path: '/loan-step-contacts',
    name: 'loan-step-contacts',
    component: LoanStepContactsPage
  },
  {
    path: '/new-customer-agreement',
    name: 'new-customer-agreement',
    component: NewCustomerAgreementPage,
    props: {
      showPepConsentLink: true,
      includeCreditRegistryConsent: false,
      showApr: false,
      showEir: true
    }
  },
  {
    path: '/without-offer-agreement',
    name: 'without-offer-agreement',
    component: WithoutOfferAgreementPage,
    props: {
      showPepConsentLink: true,
      includeCreditRegistryConsent: false,
      showApr: false,
      showEir: true
    }
  },
  {
    path: '/with-offer-agreement',
    name: 'with-offer-agreement',
    component: WithOfferAgreementPage,
    props: {
      showPepConsentLink: true,
      includeCreditRegistryConsent: false,
      showApr: false,
      showEir: true
    }
  },
  {
    path: '/account',
    name: 'account',
    component: AccountPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/update-account',
    name: 'update-account',
    component: UpdateAccountPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-application/:reference/upload',
    name: 'upload',
    component: UploadPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-application/thank-you',
    name: 'thank-you-for-loan-application',
    component: LoanApplicationThankYouPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/customer-overview',
    name: 'customer-overview',
    component: CustomerOverviewPage,
    beforeEnter: authenticatedGuard,
    props: {
      showFullDetailsForWrittenOff: true
    }
  },
  {
    path: '/loan/:id',
    name: 'loan',
    component: LoanDetailsPage,
    beforeEnter: authenticatedGuard,
    props: {
      showApr: false,
      showFullDetailsForWrittenOff: true
    }
  },
  {
    path: '/loan-application/receive-precontract',
    name: 'receive-precontract',
    component: PreContractSendPage
  },
  {
    path: '/loan/:reference/receive-contract',
    name: 'receive-loan-contract',
    component: ContractSendPage,
    props() {
      return { isDownloadable: true, isSigned: false }
    },
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan/:reference/receive-contract',
    name: 'receive-loan-contract-signed',
    component: ContractSendPage,
    props() {
      return { isDownloadable: false, isSigned: true }
    },
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan/:reference/receive-contract',
    name: 'receive-loan-contract-signed-and-paid-out',
    component: ContractSendPage,
    props() {
      return { isDownloadable: true, isSigned: true }
    },
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-application/:reference/sign',
    name: 'sign-contract',
    component: SignContractPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-application/:reference/otp-sign',
    name: 'otp-sign-contract',
    component: OtpSignContractPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-application/:id',
    name: 'loan-application',
    component: LoanApplicationDetailsPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-payment-schedule/:id',
    name: 'loan-payment-schedule',
    component: LoanPaymentSchedulePage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-payment-schedule-survey',
    name: 'loan-payment-schedule-survey',
    component: LoanPaymentScheduleSurveyPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/signing-survey',
    name: 'signing-survey',
    component: SigningSurveyPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-request-suspension/:reference',
    name: 'loan-request-suspension',
    component: LoanRequestSuspensionPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-full-repayment/:reference/:loanEndDate',
    name: 'loan-full-repayment',
    component: LoanFullRepaymentPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-closure-confirmation/:id',
    name: 'loan-closure-confirmation',
    component: LoanClosureConfirmationPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan-payment-calculator/:reference/:expectedDate/:amount/:loanStatus',
    name: 'loan-payment-calculator',
    component: LoanPaymentCalculatorPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/legal/privacy-policy',
    name: 'privacy',
    component: StaticDocumentPage,
    props: {
      documentName: 'privacy-policy'
    }
  },
  {
    path: '/legal/credit-registry-consent',
    name: 'credit-registry-consent',
    component: StaticDocumentPage,
    props: {
      documentName: 'credit-registry-consent'
    }
  },
  {
    path: '/legal/general-terms',
    name: 'general-terms',
    component: StaticDocumentPage,
    props: {
      documentName: 'general-terms',
      titleKey: 'GeneralTermsPage.title'
    }
  },
  {
    path: '/legal/pep-consent',
    name: 'pep-consent',
    component: StaticDocumentPage,
    props: {
      documentName: 'pep-consent'
    }
  },
  {
    path: '/loan/:id/payments',
    name: 'external-payments',
    component: ExternalPaymentsPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/loan/:id/payments/redirect',
    name: 'payment-redirect',
    component: PaymentRedirectPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/promotion-redirect',
    name: 'promotion-redirect',
    component: PromotionRedirectPage,
    beforeEnter: authenticatedGuard
  },
  {
    path: '/no-back',
    name: 'no-back',
    component: NoBackPage
  },
  {
    path: '/dealer-application',
    name: 'dealer-application',
    component: DealerApplicationPage,
    beforeEnter: isFastCheckoutEnabledGuard,
    props: {
      showEir: false,
      showApr: true
    }
  },
  {
    path: '*',
    beforeEnter: (to, from, next) => {
      next({ name: 'home' })
    }
  }
]
